import script from "./Ongoing.vue?vue&type=script&setup=true&lang=js"
export * from "./Ongoing.vue?vue&type=script&setup=true&lang=js"

import "./Ongoing.vue?vue&type=style&index=0&id=b4845246&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4845246"]])

export default __exports__